export const XDEVICE = 'X-DEVICE';
export const XBRAND = 'X-BRAND';
